import { Button } from "@/components/ui/button";
import logo from "@/assets/work-and-you-logo-transparent.png";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { label: "Le réseau", target: "independants" },
  { label: "Vos avantages", target: "avantages" },
  { label: "Le parcours", target: "parcours" },
  { label: "Témoignages", target: "temoignages" },
];

const scrollTo = (target: string) => {
  document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
};

const SiteHeader = () => {
  const [open, setOpen] = useState(false);

  const navigate = (target: string) => {
    setOpen(false);
    scrollTo(target);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-border/70 bg-background/95 shadow-brand-sm backdrop-blur">
      <div className="container flex h-20 items-center justify-between px-6">
        <button className="shrink-0" onClick={() => scrollTo("accueil")} aria-label="Retour en haut de page">
          <img src={logo} alt="Work&You, cabinet de recrutement" className="h-12 w-auto sm:h-14" width="1584" height="672" />
        </button>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Navigation principale">
          {links.map((link) => (
            <button key={link.target} onClick={() => navigate(link.target)} className="text-sm font-medium text-navy transition-colors hover:text-primary">
              {link.label}
            </button>
          ))}
          <Button variant="secondary" onClick={() => navigate("contact")}>Contactez-nous</Button>
        </nav>

        <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setOpen((value) => !value)} aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}>
          {open ? <X /> : <Menu />}
        </Button>
      </div>

      {open && (
        <nav className="border-t border-border bg-background px-6 py-5 lg:hidden" aria-label="Navigation mobile">
          <div className="container flex flex-col items-stretch gap-2 px-0">
            {links.map((link) => (
              <Button key={link.target} variant="ghost" className="justify-start text-navy" onClick={() => navigate(link.target)}>{link.label}</Button>
            ))}
            <Button variant="secondary" className="mt-2" onClick={() => navigate("contact")}>Contactez-nous</Button>
          </div>
        </nav>
      )}
    </header>
  );
};

export default SiteHeader;